import { ByggnadIndex, HTTP_STATUS, SearchByggnadPost } from 'models';

import { Coordinate } from 'ol/coordinate';

import { LMApi } from 'api/LMApi';

type ExtendedByggnadIndex = {
  http_status_code: HTTP_STATUS | undefined;
  byggnadIndex: ByggnadIndex[];
  requestedAtCoordinate: Coordinate;
};

export const LMByggnadSlice = LMApi.injectEndpoints({
  endpoints: (build) => ({
    searchLmByggnad: build.mutation<ExtendedByggnadIndex, Coordinate>({
      transformResponse: (response: ByggnadIndex[], meta, arg) => {
        return {
          http_status_code: meta?.response?.status,
          requestedAtCoordinate: arg,
          byggnadIndex: response
        };
      },
      query: (coordinate: Coordinate) => ({
        url: '/search/byggnad',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(createSearchByggnadPost(coordinate))
      })
    })
  })
});

const createSearchByggnadPost = (coordinates: Coordinate): SearchByggnadPost => ({
  geometri: {
    type: 'FeatureCollection',
    crs: {
      type: 'name',
      properties: {
        name: 'EPSG:3006'
      }
    },
    features: [
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates
        }
      }
    ]
  },
  buffer: 0
});

export const { useSearchLmByggnadMutation } = LMByggnadSlice;
